import { useEffect, useState } from "react";
import PageTabHeader from "./PageTabHeader";
import PageTabBody from "./PageTabBody";

export default function PageTabs({ tabs, defaultTab }) {
  const fallbackTab = defaultTab || tabs[0]?.id;
  const [activeTab, setActiveTab] = useState(fallbackTab);

  useEffect(() => {
    setActiveTab(fallbackTab);
  }, [fallbackTab]);

  return (
    <div className="w-full">
      <PageTabHeader
        tabs={tabs}
        activeTab={activeTab}
        onTabChange={setActiveTab}
      />
      <PageTabBody tabs={tabs} activeTab={activeTab} />
    </div>
  );
}
